import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18MentionG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
      fillRule: "evenodd",
      d: "M8.999 2a7 7 0 0 1 7 7l-.001.05a2.52 2.52 0 0 1-4.424 1.697 3.11 3.11 0 1 1-.612-4.16l-.001-.21a.577.577 0 0 1 1.146-.093l.007.094v2.72a1.366 1.366 0 1 0 2.733 0l.002-.045L14.846 9a5.847 5.847 0 1 0-2.94 5.074.577.577 0 1 1 .574 1A7 7 0 0 1 2 9a7 7 0 0 1 6.999-6.999zm0 5.043a1.956 1.956 0 1 0 0 3.914 1.957 1.957 0 1 0 0-3.914"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18MentionG$1 = Svg18MentionG;

export { Svg18MentionG$1 as default };
